import { PatientInsurance } from "pwapi";

import FlatResourceLine from "./FlatResourceLine";

type InsuranceLineProps = {
  insurance: PatientInsurance;
  onEditInsurance?: Function;
  onDeleteInsurance?: Function;
};

const InsuranceLine = ({
  insurance,
  onEditInsurance,
  onDeleteInsurance,
}: InsuranceLineProps) => {
  const handleOnDelete = () => {
    onDeleteInsurance && onDeleteInsurance(insurance);
  };

  return (
    <FlatResourceLine
      resource={insurance}
      onEdit={onEditInsurance}
      onDelete={onDeleteInsurance && handleOnDelete}
    >
      <span>
        {insurance.insurance_company_name}
        <br />
        Policy Number: {insurance.policy_number}
        <br />
        Group Employer ID: {insurance.group_employer_id}
        {insurance.insurance_company_address && (
          <>
            <br />
            {insurance.insurance_company_address}
            {insurance.insurance_company_address2 && (
              <>
                <br />
                {insurance.insurance_company_address2}
              </>
            )}
            <br />
            {insurance.insurance_company_city},{" "}
            {insurance.insurance_company_state}{" "}
            {insurance.insurance_company_zipcode}
          </>
        )}
      </span>
    </FlatResourceLine>
  );
};

export default InsuranceLine;
